import { render, staticRenderFns } from "./wcrd_iss_wrk_crds.vue?vue&type=template&id=71b5e10d&scoped=true&"
import script from "./wcrd_iss_wrk_crds.vue?vue&type=script&lang=js&"
export * from "./wcrd_iss_wrk_crds.vue?vue&type=script&lang=js&"
import style0 from "./wcrd_iss_wrk_crds.vue?vue&type=style&index=0&id=71b5e10d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b5e10d",
  null
  
)

export default component.exports